import ProductInfoBase from './ProductInfoBase';

export { ProductInfoBase };
